<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import { useContent } from '@/domains/investor/composables/useContent'
import { MERGER_OF_COMPANIES_CATEGORIES_SCOPE } from '@/domains/investor/merger-of-companies/const/mergerOfCompanies.const'
import Content from '@/domains/investor/components/Content/Content.vue'
import DataView from '@/domains/investor/components/DataView/DataView.vue'
import { useMergerOfCompaniesDataView } from '@/domains/investor/merger-of-companies/composables/useMergerOfCompaniesDataView'
definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorMergerOfCompanies.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorMergerOfCompanies.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorMergerOfCompanies.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorMergerOfCompanies.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorMergerOfCompanies.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorMergerOfCompanies.canonical.pl'),
    },
  ],
}))

const { getContent } = await useContent()
const mergerOfCompaniesSection = await getContent('polaczenie-spolek')

const {
  page,
  itemsPerPage,
  reports,
  reportsColumns,
  total,
  headerConfig,
  isLoading,
} = await useMergerOfCompaniesDataView({
  categoryScope: MERGER_OF_COMPANIES_CATEGORIES_SCOPE,
})

</script>

<template>
  <div>
    <InvestorHero
      :title="$t('investor.mergerOfCompanies.hero.title')"
      :lead="$t('investor.mergerOfCompanies.hero.lead')"
      image="/images/investor/hero/merger-of-companies.png"
      :first-button="{
        text: $t('investor.mergerOfCompanies.hero.firstButton.label'),
        to: $t('investor.mergerOfCompanies.hero.firstButton.to'),
      }"
    />

    <UiSection
      :id="$t('investor.mergerOfCompanies.sectionId')"
      class="merger-of-companies__section"
      color="white"
    >
      <Content :content="mergerOfCompaniesSection.data.value?.content" />

      <DataView
        v-model:page="page"
        :table-items="reports"
        :table-columns="reportsColumns"
        :total="total"
        :header="headerConfig"
        :items-per-page="itemsPerPage"
        :show-pagination="true"
        :is-loading="isLoading"
        :empty-state-message="$t('common.dataView.empty')"
        :section-id="$t('investor.mergerOfCompanies.dataView.id')"
      />
    </UiSection>
  </div>
</template>

<style scoped lang="scss">
.merger-of-companies__section {
  padding-top: 0;
}

:deep(.dataView__section) {
  @include atXL {
    padding-top: 6.4rem;
  }
}
</style>
